<template>
  <div class="commonPart">
    <header class="main-cont">
      <router-link class="logo" to="/index">
         <p>{{logo}}</p>
      </router-link>
      <div class="setList">
        <Dropdown v-if="isSmscreen" trigger="click">
          <a href="javascript:void(0)">
              <Icon type="md-menu" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="1" v-for="(item, i) in navList" :key="i">
              <router-link :to="item.link">{{item.title}}</router-link>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <nav v-if="!isSmscreen">
          <router-link v-for="(item, i) in navList" :to="item.link" :key="i">{{item.title}}</router-link>
        </nav>
      </div>
    </header>
    <router-view></router-view>
    <footer>
      <p>&copy;2020 - DAWNING TECHNOLOGY CO., LIMITED 版权所有.</p>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'commonPart',
  data () {
    return {
      logo: 'DAWNING TECHNOLOGY',
      navList: [
        {title: '首页', link: '/index'},
        {title: '服务项目', link: '/serviceProject'},
        {title: '案例展示', link: '/caseShow'},
        {title: '关于我们', link: '/aboutUs'}
      ],
      isSmscreen: false,
    }
  },
  mounted () {
    document.title = this.logo
    this.getSize()
  },
  methods: {
    getSize () {
      let that = this
      judgeScreen()
      window.addEventListener('resize', onResize, false)
      function onResize () {
        judgeScreen()
      }
      function judgeScreen () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        console.log(document.body.clientWidth)
        if (w < 780) {
          that.isSmscreen = true
          document.documentElement.style.fontSize = w / 7.5 + 'px'
        } else {
          that.isSmscreen = false
          document.documentElement.style.fontSize = '100px'
        }
      }
    }
  }
}
</script>
<style lang="scss">
.commonPart{
  header{
    padding: .2rem 0;
    @extend .flex-lay-row;
    justify-content: space-between;
    .logo p{
      font-size: .4rem;
      color: #4b4b4b;
      font-family: impact;
    }
    .setList{
      nav{
        height: 100%;
        a{
          font-size: .16rem;
          color: #777;
          display: inline-block;
          padding: .08rem .26rem;
          &.active, &.router-link-active{
            color: #2b2b2b;
          }
        }
      }
    }
    .ivu-dropdown .ivu-select-dropdown{
      right: 0;
    }
  }
  footer{
    background: #333;
    min-height: 200px;
    @extend .flex-lay-row;
    p{
      color: #777;
    }
  }
}
.ivu-icon-md-menu{
  font-size: .4rem;
  color: #333;
}
.ivu-select-dropdown{
  ul{
    li{
      a{
        font-size: 14px;
        color: #777;
        display: block;
        &.active, &.router-link-active{
          color: #2b2b2b;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dawingCommon.vue